// React
import PropTypes from "prop-types";
import { useContext, useEffect, useState } from "react";

// @mui material components
import { Card, Fade, Icon, Modal, Tooltip } from "@mui/material";

// Custom UI components
import { MessageManager } from "context";
import { ConfirmarContext } from "context/ConfirmarContext";
import { gql, useLazyQuery } from "@apollo/client";
import TimelineList from "components/Timeline/TimelineList";
import TimelineItem from "components/Timeline/TimelineItem";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { formatDate } from "utils/formatters";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxHeight: "90%",
  width: { xs: "80%", sm: "50%", md: "30%", xxl: "20%" },
  overflow: "auto",
  p: 3,
};

export default function ModalHistorial({ open, handleClose, historial }) {
  const [events, setEvents] = useState([]);

  useEffect(() => {
    if(historial?.length){
      let ev = historial.slice()
      ev.push({
        evento: "Hoy",
        fecha: new Date()
      })
      ev.sort((a, b) => new Date(a.fecha) - new Date(b.fecha));
      setEvents(ev);
    }
  }, [historial]);

  const getIcon = (evento) => {
    switch (evento) {
      case "Creación":
        return { icon: "add_circle", color: "success" };
      case "Vencimiento":
        return { icon: "event", color: "warning" };
      case "Anulada":
        return { icon: "cancel", color: "error" };
      case "Prorroga":
        return { icon: "event_repeat", color: "warning" };
      case "Cerrado con entrega parcial":
        return { icon: "assignment_return", color: "success" };
      case "Completada con entrega parcial":
      case "Completada sin entregas":
        return { icon: "done_all", color: "success" };
      case "Hoy":
        return { icon: "event", color: "primary" };
      default:
        return { icon: "circle", color: "secondary" };
    }
  }

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
    >
      <Fade in={open}>
        <Card sx={style}>
          <SoftBox display="flex" justifyContent="space-between" mb={1}>
            <SoftBox>
              <SoftTypography variant="h6">Historial de la provisión</SoftTypography>
            </SoftBox>
            <Tooltip title="Cerrar" placement="top">
              <Icon fontSize="medium" onClick={handleClose} sx={{ cursor: "pointer" }}>
                close
              </Icon>
            </Tooltip>
          </SoftBox>
          {events.length === 0 ? (
            <SoftTypography variant="caption" align="center" color="secondary">
              No hay eventos registrados
            </SoftTypography>
          ): (
            <TimelineList title="Historial de la orden">
              <SoftBox
                sx={{
                  maxHeight: "250px",
                  overflow: "auto",
                }}
              >
                {events.map((event, index) => {
                  return (
                    <TimelineItem
                      key={index}
                      title={event.evento}
                      icon={getIcon(event.evento).icon}
                      color={getIcon(event.evento).color}
                      dateTime={formatDate(event.fecha, "dd/MM/yyyy")}
                      description={event.motivo}
                    />
                  );
                })}
              </SoftBox>
            </TimelineList>
          )}
        </Card>
      </Fade>
    </Modal>
  );
}

ModalHistorial.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  historial: PropTypes.array,
};
